import { render, staticRenderFns } from "./FilterTrend.vue?vue&type=template&id=6ad32482&scoped=true"
import script from "./FilterTrend.vue?vue&type=script&lang=js"
export * from "./FilterTrend.vue?vue&type=script&lang=js"
import style0 from "./FilterTrend.vue?vue&type=style&index=0&id=6ad32482&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad32482",
  null
  
)

export default component.exports